const Reports=()=> {
  
    return (
      <div className="sticky-top bg-white border-bottom shadow-sm">
        <div className="container-fluid d-flex justify-content-between align-items-center py-3 px-3">
          <h5 className="mb-0">Reports</h5>
        </div>
      </div>
      
    );
  }
  
  export default Reports;